// Import Swiper styles
import "swiper/css";
import "swiper/css/a11y";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../../../theme/SwiperOverrides.css";

import * as styles from "./IntroRehomingCentre.module.scss";

import React, { useMemo } from "react";

import type { MediaImageProps } from "../../../components/common/MediaCarousel/MediaCarousel";
import IntroTripleCarousel from "../IntroTripleCarousel";

interface ImageProps {
	url: string;
	alt: string;
}

export interface IntroRehomingCentreProps {
	title: string;
	location: string;
	introText: string;
	images: ImageProps[];
}
export const IntroRehomingCentre: React.FC<IntroRehomingCentreProps> = ({
	title,
	location,
	introText,
	images,
}) => {
	const imagesToRender: MediaImageProps[] = useMemo(
		() =>
			images.map((image) => ({
				type: "image",
				src: image.url,
				alt: image.alt,
			})),
		[images],
	);
	return (
		<>
			<IntroTripleCarousel media={imagesToRender} isDog={false} />
			<div className={styles.bottomsection}>
				<div className={styles.headingsection}>
					<div className={styles.text}>
						<h1>{title}</h1>
						<p className={styles.location}>{location}</p>
						<p>{introText}</p>
					</div>
				</div>
			</div>
		</>
	);
};

export default IntroRehomingCentre;
